export const QUESTION_TYPES = {
  SCMCQ: "single correct mcq",
  MMCQ: "multiple correct mcq",
  INTEGER: "integer type question",
  NUMERIC: "numerical value question",
  ASSERTION_REASON: "assertion and reason",
  TRUE_FALSE: "True/False Type",
  SUBJECTIVE_VERY_SHORT: "Subjective Based Very Short Answer",
  SUBJECTIVE_SHORT: "Subjective Based Short Answer",
  SUBJECTIVE_LONG: "Subjective Based Long Answer",
  MATRIX_TWO_COLUMN: "Matrix-Match Two Column",
  PBQ: "passage based question",
  MATRIX_SCMCQ: "matrix match single correct",
} as const;
